import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginBackButton from "../../../components/SignUpLoginForgot/LoginBackButton";
import PowerGoAndSubheader from "../../../components/SignUpLoginForgot/PowerGoAndSubheader";
import ImgHeaderSubheader from "../../../components/SignUpLoginForgot/ImgHeaderSubheader";
import Button from "../../../components/Button";
import OTPfield from "../../../components/OTPfield";
import {
  LoginLayout,
  FlexWithGap,
  WidthWrapper,
  LoginInnerWrapperOther,
  OTPWrapper,
} from "../../../components/SignUpLoginForgot/LoginStyledComponents";
import { Colors, Text } from "../../../config";
import LabelLink from "../../../components/SignUpLoginForgot/LabelLink";
import ErrorModal from "../../../components/ErrorSuccessModal/ErrorModal";
import { resendOtp, verifyOtp } from "../../../services/userServices";
import { getMaskedPhone } from "../../../helper";
import { useLoaderContext } from "../../../contexts/loaderContext";
import { toast } from "react-toastify";
import { ToastMessage } from "../../../components/ToastMessage";
const nextIcon = require("../../../assets/images/Arrow_Right.png");

const ForgotOtp = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [backendErrorMsg, setBackendErrorMsg] = useState(false);
  const buttonDisabled = otp.length !== 4;
  const [phone, setPhone] = useState();
  const { setLoader } = useLoaderContext();

  const handleBackClick = () => {
    navigate("/auth/forgot");
  };

  const handleVerifyAndReset = () => {
    const forgotOtpData = {
      otp: parseInt(otp, 10),
      userId: localStorage.getItem("userId"),
    };
    postOtpData(forgotOtpData);
  };

  const postOtpData = async (forgotOtpData) => {
    console.log(forgotOtpData);
    setLoader(true);
    try {
      const response = await verifyOtp(forgotOtpData);
      console.log(response);
      if (response.status === 200) {
        setLoader(false);
        navigate("/auth/forgot/reset");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      setBackendErrorMsg(error.message);
    }
  };

  const closeErrorModal = () => {
    setBackendErrorMsg(false);
  };

  const handleResend = () => {
    const resendOtpData = {
      userId: localStorage.getItem("userId"),
    };
    postResendOtp(resendOtpData);
  };

  const postResendOtp = async (resendOtpData) => {
    console.log(resendOtpData);
    setLoader(true);
    try {
      const response = await resendOtp(resendOtpData);
      console.log(response);
      if (response.status === 200) {
        setLoader(false);
        //otp resent toast //here
        toast.success(<ToastMessage message={response.data.message} />);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      setBackendErrorMsg(error.message);
    }
  };

  useEffect(() => {
    setPhone(localStorage.getItem("phone"));
  }, []);

  return (
    <>
      <LoginBackButton onClick={handleBackClick} />
      <LoginLayout>
        <LoginInnerWrapperOther>
          <PowerGoAndSubheader />
          <WidthWrapper maxWidth="28rem">
            <ImgHeaderSubheader
              header={Text.enterVerificationCode}
              subheader={Text.a4DigitCodeSent + getMaskedPhone(phone)}
            />
          </WidthWrapper>
          <FlexWithGap gap="3rem">
            <OTPWrapper>
              <OTPfield
                label={Text.otp}
                placeholder="0"
                uniqueName="otpForgot"
                getEnteredOTP={setOtp}
                autoFocus
              />
            </OTPWrapper>
            <WidthWrapper maxWidth="22.5rem">
              <Button
                label={Text.verifyAndResetPin}
                onClick={handleVerifyAndReset}
                rightImgSrc={nextIcon}
                fontColor={Colors.white}
                fontSize="1.375rem"
                fontWeight="700"
                bgColor={Colors.brandTwo}
                topBottomPadding="0.75rem"
                labelImgGap="0.5rem"
                disabled={buttonDisabled}
              />
            </WidthWrapper>
          </FlexWithGap>
          <LabelLink
            labelText={Text.didntReceiveCodeQ}
            linkText={Text.resendCode}
            handleClick={handleResend}
            alignment="column"
          />
        </LoginInnerWrapperOther>
      </LoginLayout>
      {backendErrorMsg && (
        <ErrorModal
          subheaderText={backendErrorMsg}
          setClose={closeErrorModal}
          onButtonClick={closeErrorModal}
        />
      )}
    </>
  );
};

export default ForgotOtp;
